export const countMessageRatingsCreated = {
  analysisType: 'count',
  eventCollection: 'message.rated',
  key: 'countMessageRatingsCreated',
}
